import appConsts from "./../consts.js";
import orderService from "./../../services/orderService.js";

export default {
  namespaced: true,
  state() {
    return {
      options: {
        shouldLoad: true,
        dates: [],
        disabledWeeks: undefined,
        groupOrderMaxQuantity: 0,
        individualOrderMaxAdultQuantity: 0,
        individualOrderMaxChildrenQuantity: 0,
        perAdultMaxChildrenQuantity: 0,
        parkCloseTime: "23:59"
      }
    };
  },
  mutations: {
    setOptions(state, input) {
      state.options = input;
    }
  },
  actions: {
    async [appConsts.loadOrderOptionsAsync](context) {
      if (context.state.options.shouldLoad) {
        let options = await orderService.getOrderOptionsAsync(false, false);
        options.shouldLoad = false;

        context.commit("setOptions", options);
      }
    }
  }
};
